module.exports = __webpack_public_path__ + "img/prize-06.0423c4db.png";